import * as React from "react";
import styles from "./styles.module.scss";
import { EventVendorQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import { decodeHtmlEntities } from "@src/utils/general";

type Props = {
  eventId: number;
  eventVendorData: EventVendorQuery;
};

const Vendors: React.FC<Props> = ({ eventId, eventVendorData }) => {
  return eventVendorData?.eventVendor &&
    eventVendorData?.eventVendor.length !== 0 ? (
    <div className="px-4 bg-[#FCF8EB]">
      <section className="py-4 pb-8">
        <h3 className="text-[#75264E] font-caudex italic text-3xl lg:text-6xl font-normal text-center mb-4">
          Our Vendors
        </h3>
        <div className="border-y border-y-[#75264E] py-[2rem] sm:py-[5rem]">
          <div className="flex flex-wrap justify-center gap-8">
            {eventVendorData?.eventVendor?.map((vendor, index) => {
              const decodedName = decodeHtmlEntities(vendor?.name);
              const decodedRole = decodeHtmlEntities(vendor?.role);
              const decodedEmail = decodeHtmlEntities(vendor?.email);
              const decodedInstagramHandle = decodeHtmlEntities(
                vendor?.instagram_handle
              );

              return (
                <div
                  key={`vendors-home-page-${index}`}
                  className="p-4 flex flex-col justify-center items-center gap-2 lg:gap-4 w-full text-[#75264E] max-w-xs vendor-card"
                >
                  <div className="font-corGaramond text-2xl font-bold">
                    {decodedName}
                  </div>
                  <p className="font-corGaramond font-normal text-lg">
                    {decodedRole}
                  </p>
                  <p className="font-corGaramond font-normal text-base">
                    {decodedEmail}
                  </p>
                  <div className="flex gap-2 items-center">
                    {/* {!!vendor?.facebook && (
                      <a
                        target="_blank"
                        href={
                          vendor?.facebook.includes("@")
                            ? `https://www.facebook.com/${
                                vendor?.facebook.split("@")[1]
                              }/`
                            : `https://www.facebook.com/${vendor?.instagram_handle}/`
                        }
                        rel="noopener noreferrer"
                        className="text-[#FCF8EB]"
                      >
                        <Icon iconName="facebook" />
                      </a>
                    )}

                    {!!vendor?.twitter && (
                      <a
                        target="_blank"
                        href={
                          vendor?.twitter.includes("@")
                            ? `https://www.x.com/${
                                vendor?.twitter.split("@")[1]
                              }/`
                            : `https://www.x.com/${vendor?.twitter}/`
                        }
                        rel="noopener noreferrer"
                        className=""
                      >
                        <Icon iconName="twitterWhite" />
                      </a>
                    )} */}

                    {!!decodedInstagramHandle && (
                      <a
                        target="_blank"
                        href={
                          decodedInstagramHandle.includes("@")
                            ? `https://www.instagram.com/${
                                decodedInstagramHandle.split("@")[1]
                              }/`
                            : `https://www.instagram.com/${decodedInstagramHandle}/`
                        }
                        rel="noopener noreferrer"
                        className="text-[#FCF8EB]"
                      >
                        <Icon iconName="instagram" />
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  ) : (
    <></>
  );
};

export default Vendors;
